module.exports = __webpack_public_path__ + "img/star.068abdfb.svg";